var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "col-12 col-lg-3 mb-3", staticStyle: { height: "36px" } },
    [
      !_vm.open
        ? _c("div", { staticClass: "dropdown" }, [
            _c(
              "button",
              {
                staticClass:
                  "btn-white w-100 btn-sm no-outline segment-multioption truncate",
                on: { click: _vm.handleOpen },
              },
              [
                _vm.valuesLength != 0
                  ? _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "b-tooltip",
                            rawName: "v-b-tooltip.top",
                            value: {
                              title: _vm.valuesSelected,
                              disabled:
                                _vm.valuesSelected.length <
                                _vm.maxCharactersToDisplay,
                            },
                            expression:
                              "{\n          title: valuesSelected,\n          disabled: valuesSelected.length < maxCharactersToDisplay\n        }",
                            modifiers: { top: true },
                          },
                        ],
                        staticClass: "dropdown-toggle text-wrap",
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.truncatedValuesSelected) +
                            "\n      "
                        ),
                      ]
                    )
                  : _c("div", { staticClass: "dropdown-toggle" }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            "" +
                              _vm.$t("global.words.itemsSelected", {
                                count: _vm.valuesLength,
                              })
                          ) +
                          "\n      "
                      ),
                    ]),
              ]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.open,
              expression: "open",
            },
          ],
          staticClass:
            "hide-selection-choice segment-value-select form-group-material",
        },
        [
          _c("select2", {
            ref: "select",
            attrs: {
              id: _vm.selectId,
              data: _vm.data,
              value: _vm.multiSelectValuesIds,
              name: "value",
              options: _vm.options,
              "init-on-mounted": true,
              "format-data":
                _vm.conditionName === "Referrer"
                  ? _vm.formatReferrerData
                  : _vm.formatMultiOptionData,
              multiple: true,
              required: true,
            },
            on: { change: _vm.handleChange, close: _vm.handleClose },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }